import {
  FieldValues,
  useController,
  UseControllerProps,
} from 'react-hook-form';
import { Checkbox, CheckboxProps } from './Checkbox';

export function CheckboxForm<T extends FieldValues>({
  control,
  name,
  defaultValue,
  ...rest
}: UseControllerProps<T> & Omit<CheckboxProps, 'value' | 'onChange'>) {
  const {
    field,
    fieldState: { invalid, error },
  } = useController({ control, name, defaultValue });

  return (
    <Checkbox
      value={field.value}
      onChange={field.onChange}
      error={error?.message}
      {...rest}
    />
  );
}
